import { Link } from 'react-router-dom'
import { Chip } from '../hybrid'
import {
  formatNumber,
  type WorkspaceKnowledgeMetric,
  type WorkspaceKnowledgeStage,
} from './home-workspace-knowledge-primitives'

export function WorkspaceMetricGrid({ metrics }: { metrics: WorkspaceKnowledgeMetric[] }) {
  return (
    <div className="aw-workspace-metrics">
      {metrics.map((metric) => {
        const Icon = metric.icon
        const content = (
          <>
            <span className="aw-workspace-metric-icon">
              <Icon className="h-4 w-4" />
            </span>
            <span>
              <span>{metric.label}</span>
              <strong>{formatNumber(metric.value)}</strong>
              <small>{metric.detail}</small>
            </span>
          </>
        )
        return metric.href ? (
          <Link
            key={metric.label}
            to={metric.href}
            className={`aw-workspace-metric is-${metric.tone}`}
          >
            {content}
          </Link>
        ) : (
          <div key={metric.label} className={`aw-workspace-metric is-${metric.tone}`}>
            {content}
          </div>
        )
      })}
    </div>
  )
}

export function WorkspaceStageGrid({ stages }: { stages: WorkspaceKnowledgeStage[] }) {
  return (
    <div className="aw-workspace-stage-grid">
      {stages.map((stage, index) => {
        const Icon = stage.icon
        return (
          <div key={stage.label} className="aw-workspace-stage">
            <span className="aw-workspace-stage-icon">
              <Icon className="h-4 w-4" />
            </span>
            <Chip tone="mut">{index + 1}</Chip>
            <strong>{stage.label}</strong>
            <span>{stage.metric}</span>
            <p>{stage.detail}</p>
          </div>
        )
      })}
    </div>
  )
}
